/* Produktside: galleri-skift, antal, variantvalg, "få besked". */
(function () {
  'use strict';

  // Galleri
  /* Miniaturerne bærer et srcset, så browseren henter den størrelse, der
     passer til skærmen (før altid 1400 px ≈ 300–400 kB). Billedet byttes
     først, når det er hentet; imens toner hovedbilledet svagt, så man kan se,
     at klikket virkede. De andre billeder hentes i baggrunden efter
     indlæsning, så skiftet normalt er øjeblikkeligt. */
  var hovedBoks = document.querySelector('[data-hh-hovedbillede]');
  var hoved = hovedBoks && hovedBoks.querySelector('img');
  var thumbs = Array.prototype.slice.call(document.querySelectorAll('[data-hh-thumb]'));
  var sizes = hoved ? (hoved.getAttribute('sizes') || '(min-width: 990px) 50vw, 100vw') : '';
  var seneste = 0;

  function forhent(b) {
    if (b._hhForhentet) return b._hhForhentet;
    var img = new Image();
    img.decoding = 'async';
    img.sizes = sizes;
    if (b.getAttribute('data-hh-srcset')) img.srcset = b.getAttribute('data-hh-srcset');
    img.src = b.getAttribute('data-hh-thumb');
    b._hhForhentet = (img.decode ? img.decode() : Promise.resolve()).catch(function () {}).then(function () { return img; });
    return b._hhForhentet;
  }

  thumbs.forEach(function (b) {
    b.addEventListener('click', function () {
      if (!hoved || b.classList.contains('is-valgt')) return;
      thumbs.forEach(function (x) { x.classList.remove('is-valgt'); x.removeAttribute('aria-current'); });
      b.classList.add('is-valgt');
      b.setAttribute('aria-current', 'true');
      var nr = ++seneste;
      hovedBoks.classList.add('is-skifter');
      forhent(b).then(function (img) {
        if (nr !== seneste) return; // der er klikket på et nyere billede imens
        if (b.getAttribute('data-hh-srcset')) hoved.srcset = b.getAttribute('data-hh-srcset');
        else hoved.removeAttribute('srcset');
        hoved.sizes = sizes;
        hoved.src = img.currentSrc || b.getAttribute('data-hh-thumb');
        // Rammen tager billedets eget format, saa der ikke kommer bjaelker
        var ar = b.getAttribute('data-hh-ar');
        if (ar) hovedBoks.style.setProperty('--hh-pdp-ar', ar);
        hovedBoks.classList.remove('is-skifter');
      });
    });
  });

  // Hent de øvrige billeder, når siden er færdig – så er skiftet klar
  if (thumbs.length > 1) {
    var start = function () { thumbs.slice(1).forEach(forhent); };
    if (document.readyState === 'complete') setTimeout(start, 300);
    else window.addEventListener('load', function () { setTimeout(start, 300); });
  }

  // Zoom og fuld skærm
  /* Computer: hold musen over hovedbilledet, så zoomer det ind, hvor musen
     er (et lag med den store udgave, 2400 px, hentes ved første hover).
     Klik/tryk på billedet åbner fuld skærm med alle billeder; tryk igen for
     at zoome helt ind og træk/scroll rundt. Esc og piletaster virker. */
  (function () {
    var store = [];
    var kilder = thumbs.length ? thumbs : Array.prototype.slice.call(document.querySelectorAll('.hh-pdp__slider [data-hh-stor]'));
    kilder.forEach(function (el) { store.push(el.getAttribute('data-hh-stor')); });
    if (!store.length && hovedBoks && hovedBoks.getAttribute('data-hh-stor')) store.push(hovedBoks.getAttribute('data-hh-stor'));
    if (!store.length) return;
    var navn = (document.querySelector('.hh-pdp h1') || {}).textContent || '';

    function aktivtNr() {
      var i = thumbs.findIndex(function (t) { return t.classList.contains('is-valgt'); });
      return i < 0 ? 0 : i;
    }

    /* --- hover-zoom (kun mus) --- */
    var finMus = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    if (hovedBoks && finMus) {
      var lag = document.createElement('div');
      lag.className = 'hh-pdp__zoomlag';
      lag.setAttribute('aria-hidden', 'true');
      hovedBoks.appendChild(lag);
      var lagKilde = '';
      hovedBoks.addEventListener('mouseenter', function () {
        var k = store[aktivtNr()];
        if (k !== lagKilde) {
          lagKilde = k;
          lag.classList.remove('er-klar');
          var img = new Image();
          img.onload = function () { if (lagKilde === k) { lag.style.backgroundImage = 'url("' + k + '")'; lag.classList.add('er-klar'); } };
          img.src = k;
        }
        hovedBoks.classList.add('er-zoom');
      });
      hovedBoks.addEventListener('mousemove', function (e) {
        var r = hovedBoks.getBoundingClientRect();
        lag.style.backgroundPosition = ((e.clientX - r.left) / r.width * 100) + '% ' + ((e.clientY - r.top) / r.height * 100) + '%';
      });
      hovedBoks.addEventListener('mouseleave', function () { hovedBoks.classList.remove('er-zoom'); });
    }

    /* --- fuld skærm --- */
    var dlg = document.createElement('dialog');
    dlg.className = 'hh-lysboks';
    dlg.setAttribute('aria-label', 'Billeder af ' + navn.trim());
    dlg.innerHTML =
      '<div class="hh-lysboks__ramme" data-hh-lb-ramme><img alt="" data-hh-lb-img></div>' +
      '<button type="button" class="hh-lysboks__luk" data-hh-lb-luk aria-label="Luk">×</button>' +
      (store.length > 1 ?
        '<button type="button" class="hh-lysboks__pil hh-lysboks__pil--fra" data-hh-lb-pil="-1" aria-label="Forrige billede">‹</button>' +
        '<button type="button" class="hh-lysboks__pil hh-lysboks__pil--til" data-hh-lb-pil="1" aria-label="Næste billede">›</button>' +
        '<p class="hh-lysboks__tal" data-hh-lb-tal></p>' : '') +
      '<p class="hh-lysboks__hint">Tryk på billedet for at zoome</p>';
    document.body.appendChild(dlg);
    var ramme = dlg.querySelector('[data-hh-lb-ramme]');
    var lbImg = dlg.querySelector('[data-hh-lb-img]');
    var tal = dlg.querySelector('[data-hh-lb-tal]');
    var nr = 0;

    function vis(i) {
      nr = (i + store.length) % store.length;
      ramme.classList.remove('er-zoomet');
      lbImg.src = store[nr];
      lbImg.alt = navn.trim() + (store.length > 1 ? ', billede ' + (nr + 1) : '');
      if (tal) tal.textContent = (nr + 1) + ' / ' + store.length;
    }
    function aabn(i) {
      vis(i);
      if (dlg.showModal) dlg.showModal(); else dlg.setAttribute('open', '');
      document.documentElement.classList.add('hh-laast');
    }
    dlg.addEventListener('close', function () { document.documentElement.classList.remove('hh-laast'); });

    lbImg.addEventListener('click', function (e) {
      var r = lbImg.getBoundingClientRect();
      var fx = (e.clientX - r.left) / r.width, fy = (e.clientY - r.top) / r.height;
      var zoom = ramme.classList.toggle('er-zoomet');
      if (zoom) {
        requestAnimationFrame(function () {
          ramme.scrollLeft = fx * ramme.scrollWidth - ramme.clientWidth / 2;
          ramme.scrollTop = fy * ramme.scrollHeight - ramme.clientHeight / 2;
        });
      }
    });
    dlg.addEventListener('click', function (e) {
      if (e.target.closest('[data-hh-lb-luk]')) { dlg.close(); return; }
      var pil = e.target.closest('[data-hh-lb-pil]');
      if (pil) { vis(nr + parseInt(pil.getAttribute('data-hh-lb-pil'), 10)); return; }
      if (e.target === dlg || e.target === ramme) dlg.close();
    });
    /* Swipe mellem billederne (kun når der ikke er zoomet ind) */
    var tx = null, ty = null;
    ramme.addEventListener('touchstart', function (e) {
      if (e.touches.length !== 1) { tx = null; return; }
      tx = e.touches[0].clientX; ty = e.touches[0].clientY;
    }, { passive: true });
    ramme.addEventListener('touchend', function (e) {
      if (tx === null || ramme.classList.contains('er-zoomet') || store.length < 2) return;
      var dx = e.changedTouches[0].clientX - tx, dy = e.changedTouches[0].clientY - ty;
      if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy) * 1.5) vis(nr + (dx < 0 ? 1 : -1));
      tx = null;
    });
    dlg.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') vis(nr + 1);
      if (e.key === 'ArrowLeft') vis(nr - 1);
    });

    if (hovedBoks) {
      hovedBoks.addEventListener('click', function (e) {
        if (e.target.closest('a,button')) return;
        aabn(aktivtNr());
      });
    }
    document.querySelectorAll('.hh-pdp__slider [data-hh-stor]').forEach(function (li, i) {
      li.addEventListener('click', function () { aabn(i); });
    });
  })();

  // Antal
  var antalFelt = document.querySelector('.hh-pdp__antal input');
  document.querySelectorAll('[data-hh-antal]').forEach(function (b) {
    b.addEventListener('click', function () {
      if (!antalFelt) return;
      var n = parseInt(antalFelt.value, 10) || 1;
      n = b.getAttribute('data-hh-antal') === '+' ? n + 1 : Math.max(1, n - 1);
      antalFelt.value = n;
    });
  });

  // Variantvalg -> opdatér skjult id + URL
  var form = document.getElementById('hh-pdp-form');
  if (form && window.HHVarianter) {
    form.addEventListener('change', function () {
      var valgte = Array.prototype.map.call(
        form.querySelectorAll('.hh-pdp__radio:checked'), function (r) { return r.value; });
      var match = window.HHVarianter.find(function (v) {
        return v.options.every(function (o, i) { return o === valgte[i]; });
      });
      if (!match) return;
      /* Baade hovedformularen og den faste bjaelke i bunden har feltet */
      document.querySelectorAll('[data-hh-variant-id]').forEach(function (felt) {
        felt.value = match.id;
      });
      visVariant(match);
      var u = new URL(window.location.href);
      u.searchParams.set('variant', match.id);
      history.replaceState({}, '', u.toString());
    });

    /* Lager, varenr., pris og knap foelger den valgte variant, og udsolgte
       valg er streget over (5/10: nissen Josefine kunne vaelges som "Sidste eksemplar"). */
    var knapper = [form.querySelector('.hh-pdp__kurv'), document.querySelector('[data-hh-koebsbar] button[type=submit]')]
      .filter(Boolean);
    knapper.forEach(function (k) { k.setAttribute('data-hh-tekst', k.textContent.trim()); });

    function valgteNu() {
      return Array.prototype.map.call(form.querySelectorAll('.hh-pdp__option'), function (fs) {
        var r = fs.querySelector('.hh-pdp__radio:checked');
        return r ? r.value : null;
      });
    }

    function markerUdsolgte() {
      var valgte = valgteNu();
      form.querySelectorAll('.hh-pdp__option').forEach(function (fs, i) {
        fs.querySelectorAll('.hh-pdp__radio').forEach(function (r) {
          var proeve = valgte.slice(); proeve[i] = r.value;
          var findes = window.HHVarianter.some(function (v) {
            return v.available && v.options.every(function (o, j) { return o === proeve[j]; });
          });
          var lbl = form.querySelector('label[for="' + r.id + '"]');
          if (!lbl) return;
          lbl.classList.toggle('is-udsolgt', !findes);
          if (!findes) lbl.setAttribute('title', 'Udsolgt'); else lbl.removeAttribute('title');
        });
      });
    }

    function visVariant(v) {
      var lager = document.querySelector('.hh-pdp__lager');
      if (lager && v.lager) {
        lager.textContent = v.lager;
        lager.classList.toggle('is-udsolgt', !v.available);
      }
      var sku = document.querySelector('.hh-pdp__sku');
      if (sku) { sku.textContent = 'Varenr. ' + (v.sku || ''); sku.hidden = !v.sku; }
      var prisBoks = document.querySelector('.hh-pdp__pris');
      if (prisBoks && v.prisHtml) {
        prisBoks.querySelectorAll('.hh-pdp__pris-tal, .hh-foerpris, .hh-kort__spar').forEach(function (el) { el.remove(); });
        prisBoks.insertAdjacentHTML('afterbegin', v.prisHtml);
      }
      var bar = document.querySelector('.hh-pdp__bar-pris');
      if (bar && v.pris) {
        var lille = bar.querySelector('small');
        bar.firstChild.nodeValue = ' ' + v.pris + ' ';
        if (lille) lille.textContent = v.lagerKort || '';
      }
      knapper.forEach(function (k) {
        k.disabled = !v.available;
        k.textContent = v.available ? k.getAttribute('data-hh-tekst') : 'Udsolgt';
      });
      markerUdsolgte();
    }

    var startFelt = form.querySelector('[data-hh-variant-id]');
    var forste = startFelt && window.HHVarianter.find(function (v) { return String(v.id) === startFelt.value; });
    if (forste) visVariant(forste); else markerUdsolgte();
  }

  // "Få besked"
  var aabn = document.querySelector('[data-hh-besked-aabn]');
  var boks = document.querySelector('[data-hh-besked]');
  if (aabn && boks) {
    aabn.addEventListener('click', function () {
      var vis = boks.hidden;
      boks.hidden = !vis;
      aabn.setAttribute('aria-expanded', vis ? 'true' : 'false');
      if (vis) { var f = boks.querySelector('input[type=email]'); if (f) f.focus(); }
    });
  }
})();
